<template>
    <!-- view a selected transaction -->
    <app-ghost-mode v-if="viewTransaction">
        <div class="row">
            <div class="col-12">
                <div class="jumbotron bg-white screen-center view-transaction p-4">
                    <h3 class="my-4 small-text"><span class="text-dark-green">aNewItem</span> Transaction Details</h3><hr>
                    <dl class="row">
                        <dt class="col-sm-3">Transaction:</dt>
                        <dd class="col-sm-9"><p>{{transactionDetails.number}}</p></dd>
                        
                        <dt class="col-sm-3">Operation:</dt>
                        <dd class="col-sm-9"><p>{{transactionDetails.event | capitalize}}</p></dd>

                        <dt class="col-sm-3">Initiator:</dt>
                        <dd class="col-sm-9">
                            <p class="text-capitalize">
                                {{user.name}} @{{user.userHandle}}
                                <router-link :to="{ name: 'lookup-handle', params: { handle: user.userHandle } }" class="text-dark-green text-lowercase">
                                    (me)
                                </router-link>
                            </p>
                        </dd>

                        <template v-if="transactionDetails.item">
                            <dt class="col-sm-3">Item Title:</dt>
                            <dd class="col-sm-9"><p>{{transactionDetails.item.title | capitalize}}</p></dd>

                            <dt class="col-sm-3">Item Seller:</dt>
                            <dd class="col-sm-9">
                                <p class="text-capitalize">
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: transactionDetails.item.seller.handle } }">
                                        {{transactionDetails.item.seller.name}} @{{transactionDetails.item.seller.handle}} 
                                        <span v-if="transactionDetails.item.seller.shopOwner" class="text-dark-green">
                                            <i class="fas fa-store ml-2"></i> {{transactionDetails.item.seller.shopName}}
                                        </span>
                                    </router-link>
                                </p>
                            </dd>
                            
                            <dt class="col-sm-3">Item Buyer:</dt>
                            <dd class="col-sm-9">
                                <p class="text-capitalize">
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: transactionDetails.item.buyer.handle } }">
                                        {{transactionDetails.item.buyer.name}} @{{transactionDetails.item.buyer.handle}} 
                                        <span v-if="transactionDetails.item.buyer.shopOwner" class="text-dark-green">
                                            <i class="fas fa-store ml-2"></i> {{transactionDetails.item.buyer.shopName}}
                                        </span>
                                    </router-link>
                                </p>
                            </dd>
                            
                            <dt class="col-sm-3">Item Cost:</dt>
                            <dd class="col-sm-9"><p class="text-uppercase">{{transactionDetails.item.seller.currency}} {{transactionDetails.item.price | money}}</p></dd>
                            
                            <dt class="col-sm-3">Sold Price:</dt>
                            <dd class="col-sm-9"><p class="text-uppercase">{{transactionDetails.item.seller.currency}} {{transactionDetails.item.soldPrice | money}}</p></dd>
                        </template>
                        
                        <dt class="col-sm-3">Time:</dt>
                        <dd class="col-sm-9"><p>{{transactionDetails.joined | moment("MMMM Do YYYY, h:mm:ss A")}}</p></dd>
                        
                        <dt class="col-12 mt-2">
                            <!-- show the accurate review buttons to both buyer and seller -->
                            <template v-if="transactionDetails.item">
                                <template v-if="transactionDetails.item.seller.id === user._id">
                                    <button v-if="!transactionDetails.item.sellerReviewed" @click="reviewUserBtn('buyer')" class="loadn btn btn-dark"><i class="fas fa-star text-warning"></i> Review Buyer</button>
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: transactionDetails.item.buyer.handle } }" 
                                    v-else class="btn btn-dark"><i class="fas fa-check text-dark-green"></i> Reviewed Buyer</router-link>
                                </template>
                                <template v-if="transactionDetails.item.buyer.id === user._id">
                                    <button v-if="!transactionDetails.item.buyerReviewed" @click="reviewUserBtn('seller')" class="loadn btn btn-dark"><i class="fas fa-star text-warning"></i> Review Seller</button>
                                    <router-link :to="{ name: 'lookup-handle', params: { handle: transactionDetails.item.seller.handle } }" 
                                    v-else class="btn btn-dark"><i class="fas fa-check text-dark-green"></i> Reviewed Seller</router-link>
                                </template>
                            </template>
                        </dt>
                    </dl>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventBus } from '@/main'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    props: ['transactionId'],
    data() {
        return {
            viewTransaction: false,
            transactionDetails: false
        }
    },
    methods: {
        ...mapActions(['reviewTransaction']),
        fetchSingleTransaction(transactionId) {
            this.viewTransaction = true
            // fetch the transaction details from the getters.transactions
            let fullTransactionDetails = this.transactions.find(transaction => transaction.id == transactionId)
            return this.transactionDetails = fullTransactionDetails
        },
        reviewUserBtn(position) {
            if(this.transactionDetails){
                // determine the user handle
                let theUserHandle = ''
                if(position == 'buyer'){ theUserHandle = this.transactionDetails.item.buyer.handle }
                if(position == 'seller'){ theUserHandle = this.transactionDetails.item.seller.handle }

                // prepare the review-transaction obj
                let reviewObj = {
                    itemId: this.transactionDetails.item.id,
                    sellerId: this.transactionDetails.item.seller.id,
                    buyerId: this.transactionDetails.item.buyer.id
                }
                this.reviewTransaction(reviewObj)
                .then(() => {
                    this.$router.push({
                        name: 'lookup-handle',
                        params: {
                            handle: theUserHandle,
                            itemId: this.transactionDetails.item.id
                        }
                    }).catch((e) => {})
                })
                .catch((e) => {})
            }
        }
    },
    computed: {
        ...mapGetters(['transaction', 'transactions', 'user']),
        itemTransaction() {
            if(this.transaction && this.transaction !== null){
                return this.transaction[0]
            }else{
                return false
            }
        },
    },
    components: {
        appGhostMode: GhostMode
    },
    watch: {
        transactionId() {
            this.fetchSingleTransaction(this.transactionId)
        }
    },
    created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.viewTransaction = value
        })
    },
    mounted() {
        // auto display the item transaction requested from MarkAsSold receipt btn
        if(this.itemTransaction){
            this.transactionDetails = this.itemTransaction
            this.viewTransaction = true
        }
    },
}
</script>